import { render, staticRenderFns } from "./SaaS.vue?vue&type=template&id=a7af2de0&"
import script from "./SaaS.vue?vue&type=script&lang=js&"
export * from "./SaaS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports